import request from '../../../../setup/axios/request'

export const signProductFileFast = (data: any) => {
  return request({
    url:
      '/api/v1/FileManager/sign-product-file-fast?id=' +
      data.id +
      '&type=' +
      data.type +
      '&idDetails=' +
      data.idDetails +
      '&groupDomain=' +
      data.groupDomain +
      '&refId=' +
      data.refId,
    method: 'get',
  })
}
